import React, { useEffect } from "react";
import { DataTypes } from "../../../../constants";
import { Container, Grid } from "@mui/material";
import PDPCard from "./PDPCard";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import Fetching from "../../../Common/Fetching";
import rmsActions from "../../../../actions/rmsActions";
import { getPDPs, getRmsAppCode, isFetching } from "../../../../reducers";
import { useSelector, useDispatch } from "react-redux";


function PDPList() {
    const isFetchingStatus = useSelector((state) => isFetching(state, DataTypes.PDPS));
    const pdps = useSelector(getPDPs);
    const appCode = useSelector(getRmsAppCode);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!!appCode) {
            dispatch(rmsActions.getPDPs(appCode));
        }
    }, [dispatch, appCode]);

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                {isFetchingStatus && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}

                {!!pdps && Array.isArray(pdps) &&
                    pdps.map((pdp) => (
                        <Grid item xs={12} key={pdp.id}>
                            <PDPCard pdp={pdp} />
                        </Grid>
                    ))
                }
            </Grid>
        </Container>
    );
}

export default PDPList;
